import { useQuery } from "react-query";
import {
  BookingScheduleDto,
  BookingScheduleInterface
} from "../../../features/Booking-Form/typings/booking.types";
import { fetchVisitOnlySchedule } from "./visit-only-schedule.api";
import { SCHEDULE_QUERY_STALE_TIME_MS } from "./schedule-query-cache.constants";

export function useRemoteFetchVisitOnlySchedule(
  bookingScheduleDto: BookingScheduleDto,
  visitorManagementEnabled: boolean
) {
  const { startDate, endDate } = bookingScheduleDto;

  return useQuery<BookingScheduleInterface[]>(
    ["visitOnlySchedule", bookingScheduleDto],
    async () => {
      const res = await fetchVisitOnlySchedule(bookingScheduleDto);
      return res.data;
    },
    {
      enabled: !!startDate && !!endDate && visitorManagementEnabled,
      refetchOnWindowFocus: false,
      staleTime: SCHEDULE_QUERY_STALE_TIME_MS
    }
  );
}
